import React, { useEffect, useState } from "react";
import { Card, Grid, Typography, Avatar, Box } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const notificationsData = [
  { id: 1, message: "New job application received", icon: <WorkIcon />, timestamp: "10 mins ago", read: false },
  { id: 2, message: "New candidate registered", icon: <PersonAddIcon />, timestamp: "30 mins ago", read: false },
  { id: 3, message: "Job position filled", icon: <CheckCircleIcon />, timestamp: "1 hour ago", read: false },
  { id: 4, message: "Application rejected", icon: <CancelIcon />, timestamp: "2 hours ago", read: false },
  { id: 1, message: "New job application received", icon: <WorkIcon />, timestamp: "10 mins ago", read: true },
  { id: 2, message: "New candidate registered", icon: <PersonAddIcon />, timestamp: "30 mins ago", read: true },
  { id: 3, message: "Job position filled", icon: <CheckCircleIcon />, timestamp: "1 hour ago", read: true },
  { id: 4, message: "Application rejected", icon: <CancelIcon />, timestamp: "2 hours ago", read: true },
  { id: 1, message: "New job application received", icon: <WorkIcon />, timestamp: "10 mins ago", read: true },
  { id: 2, message: "New candidate registered", icon: <PersonAddIcon />, timestamp: "30 mins ago", read: true },
  { id: 3, message: "Job position filled", icon: <CheckCircleIcon />, timestamp: "1 hour ago", read: true },
  { id: 4, message: "Application rejected", icon: <CancelIcon />, timestamp: "2 hours ago", read: true },
  { id: 1, message: "New job application received", icon: <WorkIcon />, timestamp: "10 mins ago", read: true },
  { id: 2, message: "New candidate registered", icon: <PersonAddIcon />, timestamp: "30 mins ago", read: true },
  { id: 3, message: "Job position filled", icon: <CheckCircleIcon />, timestamp: "1 hour ago", read: true },
  { id: 4, message: "Application rejected", icon: <CancelIcon />, timestamp: "2 hours ago", read: true },
];

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState(notificationsData);

  const handleRead = (id) => {
    setNotifications(
      notifications.map((notif) =>
        notif.id === id ? { ...notif, read: true } : notif
      )
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ p: 4, mx: "auto" }}>
      <Typography sx={{
        fontSize: { xs: "16px", sm: "18px", lg: "22px" },
        fontWeight: 700,
        marginBottom: 5
      }}>Notifications</Typography>
      <Grid container spacing={3}>
        {notifications.map(({ id, message, icon, timestamp, read }) => (
          <Grid item xs={12} key={id}>
            <Card
              onClick={() => handleRead(id)}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                gap: 2,
                cursor: "pointer",
                opacity: read ? 0.5 : 1,
                transition: "opacity 0.3s",
              }}
            >
              <Avatar sx={{ bgcolor: read?'grey':"#006CB8" }}>{icon}</Avatar>
              <Box>
                <Typography variant="body1" fontWeight={600}>{message}</Typography>
                <Typography variant="body2" color="textSecondary">{timestamp}</Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}